/**
 * Payment Domain Errors
 *
 * Typed errors for payment operations.
 */

export type PaymentErrorCode = 'GET_PAY_TYPES_FAILED' | 'PROCESSING_FAILED' | 'NOT_AVAILABLE' | 'UNKNOWN'

export class PaymentError extends Error {
  readonly code: PaymentErrorCode
  readonly cause?: unknown

  constructor(code: PaymentErrorCode, cause?: unknown) {
    super(PaymentError.getMessageForCode(code))
    this.name = 'PaymentError'
    this.code = code
    this.cause = cause
  }

  private static getMessageForCode(code: PaymentErrorCode): string {
    const messages: Record<PaymentErrorCode, string> = {
      GET_PAY_TYPES_FAILED: 'Failed to get payment types',
      PROCESSING_FAILED: 'Payment processing failed',
      NOT_AVAILABLE: 'Payment method is not available',
      UNKNOWN: 'Unknown payment error',
    }
    return messages[code]
  }
}
